module.exports = __webpack_public_path__ + "media/images/vp/icon.profile.tg.red-e78c3d9f7e662464ac9ec233d151f733.svg";